import { render, staticRenderFns } from "./GeneralDealDetails.vue?vue&type=template&id=c0a7afa8&"
import script from "./GeneralDealDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDealDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDealDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports